import {Component, ViewChild, OnInit, TemplateRef, EventEmitter, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalService } from '../../../services/modal.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModeloMediador } from '../../../model/modelomediador';
import { CadastrosService } from '../../../services/cadastros.service';

@Component({
  selector: 'app-detalhes-modelomediador',
  templateUrl: 'modelomediador-detalhes.component.html'
})
export class ModeloMediadorDetalhesComponent implements OnInit{

  @ViewChild('modalmodelomediador', {static: false}) public modalmodelomediador: ModalDirective;

  sub: boolean = false;
  _modelomediador: ModeloMediador = new ModeloMediador();
  @Output() loadmodelomediador = new EventEmitter();
  titulo: string = "Novo modelomediador";
  movSubSalvar: Subscription;
  movSubAlterar: Subscription;
  movSub: Subscription;

  constructor(
    private modalService: ModalService,
    private toastr: ToastrService,
    private cadastrosService: CadastrosService) {
  }

  ngOnInit() {

    if(this.sub == false){

      this.sub = true;

      this.modalService.modalDetalhesModeloMediador.subscribe(
        (p: ModeloMediador) => {

          if(p == null){
            this.titulo = "Novo Modelo Mediador"
            this._modelomediador = new ModeloMediador();
          }else{
            this.titulo = "Editar Modelo Mediador"
            this._modelomediador = p;
          }

          this.limpaModal();

          this.modalmodelomediador.show();

        }, error => {
          console.log(error.message);
        }
      );
    }

  }

  hideModal(){
    this.modalmodelomediador.hide();
    this.loadmodelomediador.emit();
  }

  limpaModal(){
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  onSubmit(form: NgForm) {

    if (!form.valid) {
      return;
    }


    if(this.titulo == "Editar Modelo Mediador"){
      this.atualizar();
    }else{
      this.salvar();
    }

    form.reset();
  }

  salvar(){

    let objmodelomediador = JSON.parse(JSON.stringify(this._modelomediador));

    this.cadastrosService.salvar("modelomediador/insert", objmodelomediador).subscribe(
      (result) =>{

        this.toastr.success('Modelo Mediador cadastrado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );



  }

  atualizar(){

    let objmodelomediador = JSON.parse(JSON.stringify(this._modelomediador));

    this.cadastrosService.atualizar("modelomediador/update", objmodelomediador, objmodelomediador.id).subscribe(
      (result) =>{

        this.toastr.success('Modelo Mediador atualizado com sucesso!', 'Sucesso!');
        console.log(result);

        this.hideModal();

      },
      error=> {

        this.toastr.error(error.message, 'Erro!');
        console.log(error);

        this.hideModal();
      }

    );
  }
}
